import { render, staticRenderFns } from "./wjAssemble.vue?vue&type=template&id=435b1d2f&scoped=true"
import script from "./wjAssemble.vue?vue&type=script&lang=js"
export * from "./wjAssemble.vue?vue&type=script&lang=js"
import style0 from "./wjAssemble.vue?vue&type=style&index=0&id=435b1d2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b1d2f",
  null
  
)

export default component.exports